import {AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from '../../../../core/visbos-core/components/abstract-visbos.component';
import {MovingDirection, WizardComponent} from "ng2-archwizard/dist";
import {SessionActions} from '../../../../shared/actions';
import {ActivatedRoute, Router} from '@angular/router';
import {MarriageService} from '../../services/marriage.service';
import {MessageType} from '../../../../shared/redux-store/session';

@Component({
  selector: 'vb-asset-marriage-wizard',
  templateUrl: './asset-marriage-wizard.component.html',
  styleUrls: ['./asset-marriage-wizard.component.css']
})
export class AssetMarriageWizardComponent extends AbstractVisbosComponent implements OnInit, AfterViewInit, OnDestroy {

  MovingDirection;

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  currentStep: number;

  @Input()
  readerId = '';

  canExitPackingPageProxy = (direction: MovingDirection) => this.canExitPackingPage.apply(this, [direction]);
  canExitItemsPageProxy = (direction: MovingDirection) => this.canExitItemsPage.apply(this, [direction]);

  private isSaved: boolean = false;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private router: Router, private activatedRoute: ActivatedRoute,
              private marriageService: MarriageService) {
    super(sessionActions, cd);

    this.MovingDirection = MovingDirection;

  }

  onStepChanged() {
    let step = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
    this.currentStep = step;
    this.cd.detectChanges();
  }

  onFinalStepEntered() {
    this.onStepChanged();
    this.marriageService.saveCurrentMarriage()
      .subscribe(
        res => {
          this.sessionActions.pushMessage("Verpackungshierarchie erfolgreich gespeichert", MessageType.SUCCESS, 'Verpackungshierarchie');
          this.gotoStart();
        },
        err => this.sessionActions.throwError(err, 'Fehler beim Speichern der Verpackungshierarchie')
      )
  }

  canExitPackingPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      if (this.marriageService.getCurrentParentAsset().getValue()) {
        return true;
      }
    }

    return false;

  }

  canExitItemsPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {

      const l = this.marriageService.getCurrentChildrenCuids().length;
      if (l > 0) {
        return true;
      } else {
        return false;
      }

    } else {
      return true;
    }

  }

  forwardSealPageLabel() {
    if (this.marriageService.getCurrentSeal().getValue()) {
      return 'Weiter mit Plombe';
    } else {
      return 'Verplombung überspringen';
    }
  }

  gotoStart() {
    this.marriageService.reset();
    this.wizard.navigation.reset();
  }


}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/asset-marriage-wizard/asset-marriage-wizard.component.ts